module.exports = __webpack_public_path__ + "static/img/study_report.c5a96751.png";